import * as ActionTypes from 'constants';

const defaultState = (initial_state = {}) => ({
  message: '',
  filters: {},
  results: [],
  size: 100,
  offset: 0,
  sort: {
    prop: 'date_created',
    order: 'desc'
  },
  total: 0,
  fetching: false,
  loading: false,
  creating: false,
  updating: false,
  deleting: false,
  last_created_id: undefined,
  last_updated_id: undefined,
  last_deleted_id: undefined,
  ...initial_state
});

const document_manager = (TYPE, initial_state = {}) => (state = defaultState(initial_state), action = {}) => {
  const { type, payload } = action;

  switch(type) {
    case `${TYPE}_CREATE`:
      return { ...state, creating: true, loading: true, error: null }
    case `${TYPE}_UPDATE`:
      return { ...state, updating: true, loading: true, error: null }
    case `${TYPE}_DELETE`: {
      return { ...state, deleting: true, loading: true, error: null }
    }
    case `${TYPE}_FETCH`: {
      return { ...state, fetching: true, loading: true, error: null }
    }
    case `${TYPE}_FETCH_SUCCESS`: {
      return {
        ...state,
        results: payload.results || [],
        size: payload.size,
        offset: payload.offset,
        sort: payload.sort,
        total: payload.total,
        fetching: false,
        loading: false,
        error: false,
      };
    }
    case `${TYPE}_CREATE_SUCCESS`: {
      return {
        ...state,
        results: [payload, ...state.results],
        loading: false,
        creating: false,
        error: false,
        last_created_id: payload._id
      };
    }
    case `${TYPE}_UPDATE_SUCCESS`: {
      let idx = -1;
      const item = state.results.find((item, index) => {
        const truthy = item._id == payload._id;
        if(truthy) {
          idx = index;
        }
        return truthy;
      });
      return {
        ...state,
        results: item? [
          ...state.results.slice(0, idx),
          payload,
          ...state.results.slice(idx+1, state.results.length)
        ] : state.results,
        loading: false,
        updating: false,
        error: false,
        last_updated_id: payload._id
      };
    }
    case `${TYPE}_DELETE_SUCCESS`: {
      return {
        ...state,
        results: state.results.filter(item => item._id != payload._id),
        loading: false,
        deleting: false,
        error: false
      }
    }
    case `${TYPE}_CREATE_FAILED`: {
      return { ...state, loading: false, creating: false, error: payload }
    }
    case `${TYPE}_UPDATE_FAILED`: {
      return { ...state, loading: false, updating: false, error: payload }
    }
    case `${TYPE}_DELETE_FAILED`: {
      return { ...state, loading: false, deleting: false, error: payload }
    }
    case `${TYPE}_FETCH_FAILED`: {
      return { ...state, loading: false, fetching: false, error: payload }
    }
    case `${TYPE}_CLEAR_STATE`: {
      return defaultState();
    }
    default: {
      return state;
    }
  }
}

export const sales_site_manager = (state = {
  page_manager: document_manager('PAGE')(),
  section_manager: document_manager('SECTION')(),
  page_template_manager: document_manager('PAGE_TEMPLATE')(),
  section_template_manager: document_manager('SECTION_TEMPLATE')()
}, action) => {

  const { payload, type } = action;

  if(type.match(/^PAGE_TEMPLATE/gi)) {
    return {
      ...state,
      page_template_manager: document_manager('PAGE_TEMPLATE')(state.page_template_manager, action)
    }
  }

  if(type.match(/^PAGE/gi)) {
    return {
      ...state,
      page_manager: document_manager('PAGE')(state.page_manager, action)
    }
  }

  if(type.match(/^SECTION_TEMPLATE/gi)) {
    return {
      ...state,
      section_template_manager: document_manager('SECTION_TEMPLATE')(state.section_template_manager, action)
    }
  }

  if(type.match(/^SECTION/gi)) {
    return {
      ...state,
      section_manager: document_manager('SECTION')(state.section_manager, action)
    }
  }

  switch(type) {
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/sales-site-manager.js